export class DiamFailure {
    static NO_MORE_PIECES_OF_THIS_TYPE = () => $localize `You do not have any pieces of this type anymore.`;
    static SPACE_IS_FULL = () => $localize `You cannot play here: this space is already full.`;
    static TARGET_STACK_TOO_HIGH = () => $localize `You cannot add more pieces to the target stack, as it will contain more than 4 pieces.`;
    static MUST_SHIFT_TO_NEIGHBOR = () => $localize `To perform a shift, you must move the pieces to a neighboring space.`;
    static MUST_SELECT_PIECE_FIRST = () => $localize `You must first select either a piece from the side, or a stack of pieces to shift on the board.`;
}
